/* ---------------------------------------------------------------
   overrides.js  —  Lädt NACH theme.js (siehe layout/theme.liquid)

   1) Geschenk-Kachel mit Bild in der Warenkorb-Schublade.
   2) Name des Geschenks aus den Einstellungen (data-gift-name).
   3) Produkte, die das Geschenk schon enthalten (Mega Party Set),
      lösen die Schwelle nicht aus — data-gift-exclude.
   4) Ab der Schwelle wird das Geschenk automatisch in den Warenkorb
      gelegt und wieder entfernt, sobald der Wert darunter fällt.
      Die Prüfung läuft bei JEDEM Seitenaufruf, nicht nur wenn die
      Schublade offen ist.
   5) Die Geschenk-Zeile wird als solche dargestellt: Preis
      durchgestrichen, „GRATIS“, kein Mengen-Regler.
      Der Rabatt selbst kommt vom automatischen Rabatt in Shopify
      „Thermobecher gratis ab 100 €“ — nicht von hier.

   Entfernt der Kunde das Geschenk selbst, kommt es in dieser Sitzung
   nicht zurück.

   2026-07-27: + PDP-Lightbox (Zoom aufs Produktbild) — ganz unten.
   2026-07-29: + Build-Your-Box 3D-Fallback — ganz unten.
   --------------------------------------------------------------- */
(function(){
  'use strict';

  var BUSY = false;

  function attr(name, fallback){
    var v = document.body && document.body.getAttribute(name);
    return (v === null || v === undefined || v === '') ? fallback : v;
  }
  function money(cents){
    return (window.CCmoney || function(c){ return (c/100).toFixed(2).replace('.', ',') + ' €'; })(cents);
  }
  function giftMin(){ return Number(attr('data-free-gift', 0)) * 100; }
  function shipMin(){ return Number(attr('data-free-shipping', 49)) * 100; }
  function giftVariant(){ return String(attr('data-gift-variant','')).trim(); }
  function isCartPage(){ return String(attr('data-tpl','')) === 'cart'; }

  function memo(key, value){
    try {
      if (value === undefined) return sessionStorage.getItem(key);
      sessionStorage.setItem(key, value);
    } catch(e){}
    return null;
  }

  function hasBundledGift(cart){
    var raw = String(attr('data-gift-exclude','')).trim();
    if (!raw) return false;
    var list = raw.toLowerCase().split(',').map(function(s){ return s.trim(); }).filter(Boolean);
    if (!list.length) return false;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++){
      var h = String(items[i].handle || '').toLowerCase();
      var p = String(items[i].product_id || '');
      if (list.indexOf(h) > -1 || list.indexOf(p) > -1) return true;
    }
    return false;
  }

  function giftLine(cart){
    var vid = giftVariant();
    if (!vid) return null;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++){
      if (String(items[i].variant_id) === vid) return { index: i + 1, item: items[i] };
    }
    return null;
  }

  function eligible(cart){
    var line = giftLine(cart);
    var giftValue = line ? (line.item.final_line_price || 0) : 0;
    return ((cart && cart.total_price) || 0) - giftValue;
  }

  function afterChange(cart){
    if (window.CCrefreshCart) { try { window.CCrefreshCart(); } catch(e){} }
    if (isCartPage()){ location.reload(); return; }
    if (window.CD && window.CD.render && window.CD.el){ try { window.CD.render(cart); } catch(e){} }
  }

  function syncGift(cart){
    if (BUSY) return;
    var vid = giftVariant(), min = giftMin();
    if (!vid || min <= 0) return;

    var line    = giftLine(cart);
    var bundled = hasBundledGift(cart);
    var count   = ((cart && cart.items) || []).length;
    var value   = eligible(cart);

    if (!line && value >= min && memo('cc_gift_added') === '1'){
      memo('cc_gift_declined', '1');
      memo('cc_gift_added', '0');
    }

    if (!line && !bundled && count > 0 && value >= min && memo('cc_gift_declined') !== '1'){
      BUSY = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1,
          properties: { 'Geschenk': 'ab ' + (min / 100) + ' €' } }] })
      })
        .then(function(r){ if (!r.ok) throw r; return fetch('/cart.js'); })
        .then(function(r){ return r.json(); })
        .then(function(c){ BUSY = false; memo('cc_gift_added','1'); afterChange(c); })
        .catch(function(){ BUSY = false; });
      return;
    }

    if (line && (bundled || value < min)){
      BUSY = true;
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line.index, quantity: 0 })
      })
        .then(function(r){ return r.json(); })
        .then(function(c){ BUSY = false; memo('cc_gift_added','0'); afterChange(c); })
        .catch(function(){ BUSY = false; });
    }
  }

  /* ---------- Anzeige ---------- */

  function setShipText(cart){
    var el = document.querySelector('[data-cd-ship]');
    if (!el) return;
    var count = ((cart && cart.items) || []).length;
    if (!count){ el.textContent = ''; return; }
    var calc  = window.CD && window.CD.calc;
    var after = calc ? (calc.sub - calc.disc) : (cart.total_price || 0);
    var free  = shipMin();
    if ((calc && calc.freeShip) || after >= free) el.textContent = '🎉 Versandkostenfrei!';
    else el.textContent = 'Noch ' + money(free - after) + ' bis zum Gratisversand';
  }

  function setGiftBox(cart, bundled){
    var box = document.querySelector('[data-cd-giftbox]');
    if (!box) return;
    var count = ((cart && cart.items) || []).length;
    var min   = giftMin();
    if (bundled || !count || min <= 0){ box.hidden = true; return; }

    var value  = eligible(cart);
    var inCart = !!giftLine(cart);
    var txt    = box.querySelector('[data-cd-gifttxt]');

    box.hidden = false;
    if (value >= min){
      box.classList.add('is-on');
      if (txt) txt.textContent = inCart ? '✓ Liegt in deiner Box — gratis' : '✓ Gesichert';
    } else {
      box.classList.remove('is-on');
      if (txt) txt.textContent = 'Noch ' + money(min - value) + ' — dann gehört er dir';
    }
  }

  function setMilestones(cart, bundled){
    var gift = document.querySelector('[data-ms=gift]');
    var ship = document.querySelector('[data-ms=ship]');
    var old  = document.querySelector('[data-cd-gift]');
    if (old) old.hidden = true;

    if (!bundled){ if (gift) gift.style.display = ''; return; }

    if (gift) gift.style.display = 'none';
    if (ship) ship.style.left = '100%';

    var calc = window.CD && window.CD.calc;
    if (!calc) return;
    var bar   = document.querySelector('[data-cd-bar]');
    var count = ((cart && cart.items) || []).length;
    var after = calc.sub - calc.disc;
    if (bar) bar.style.width = count ? Math.min(100, Math.round(after / shipMin() * 100)) + '%' : '0%';
  }

  /* Geschenk-Zeile kenntlich machen: durchgestrichen + GRATIS */
  function decorateLines(cart){
    var rows  = document.querySelectorAll('[data-cd-lines] .cd-line');
    var items = (cart && cart.items) || [];
    var vid   = giftVariant();

    for (var i = 0; i < rows.length && i < items.length; i++){
      var it = items[i], row = rows[i];
      var isGift  = vid && String(it.variant_id) === vid;
      var cheaper = it.final_line_price < it.original_line_price;
      if (!isGift && !cheaper) continue;

      row.classList.add('cd-line-gift');

      var price = row.querySelector('.cp');
      if (price){
        price.innerHTML = '<s>' + money(it.original_line_price) + '</s>' +
          '<span class="cp-free">' +
          ((isGift || it.final_line_price === 0) ? 'GRATIS' : money(it.final_line_price)) +
          '</span>';
      }

      if (isGift){
        var q = row.querySelector('.cd-q');
        if (q){
          var m = q.querySelector('[data-cd-minus]'); if (m) m.style.display = 'none';
          var p = q.querySelector('[data-cd-plus]');  if (p) p.style.display = 'none';
          var n = q.querySelector('i');               if (n) n.style.display = 'none';
        }
        var title = row.querySelector('.ct b');
        if (title && !title.querySelector('.cd-gift-tag')){
          var tag = document.createElement('span');
          tag.className = 'cd-gift-tag';
          tag.textContent = 'Geschenk';
          title.appendChild(tag);
        }
      }
    }
  }

  function paint(cart){
    var bundled = hasBundledGift(cart);
    setMilestones(cart, bundled);
    setShipText(cart);
    setGiftBox(cart, bundled);
    decorateLines(cart);
  }

  function patch(){
    if (!window.CD || typeof window.CD.sums !== 'function') return false;
    if (window.CD.__giftPatched) return true;

    var orig = window.CD.sums;
    window.CD.sums = function(cart){
      orig.call(window.CD, cart);
      try { paint(cart); syncGift(cart); } catch(e){}
    };
    window.CD.__giftPatched = true;
    if (window.CD.lastCart){ try { paint(window.CD.lastCart); } catch(e){} }
    return true;
  }

  function boot(){
    if (!giftVariant() || giftMin() <= 0) return;
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(c){ try { syncGift(c); } catch(e){} })
      .catch(function(){});
  }

  if (!patch()){
    var tries = 0;
    var t = setInterval(function(){ if (patch() || ++tries > 40) clearInterval(t); }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();

/* ---------------------------------------------------------------
   2026-07-27: PDP-Lightbox — Klick aufs Produktbild öffnet die
   Großansicht als Overlay. Klick daneben, ✕ oder Escape schließt.
   Styles: overrides.css, Abschnitt 11.
   --------------------------------------------------------------- */
(function(){
  'use strict';
  function init(){
    var main = document.getElementById('pdpMain');
    if (!main || document.getElementById('pdpZoom')) return;
    var ov = document.createElement('div');
    ov.id = 'pdpZoom';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-label', 'Bild-Großansicht');
    ov.innerHTML = '<img alt=""><button class="pz-x" type="button" aria-label="Schließen">✕</button>';
    document.body.appendChild(ov);
    var img = ov.querySelector('img');
    function open(){ img.src = main.src; ov.classList.add('open'); document.documentElement.style.overflow = 'hidden'; }
    function close(){ ov.classList.remove('open'); document.documentElement.style.overflow = ''; }
    main.addEventListener('click', open);
    ov.addEventListener('click', function(e){ if (e.target !== img) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* ---------------------------------------------------------------
   2026-07-29: Build-Your-Box 3D-Fallback — three.js kommt von cdnjs
   (Adblocker/Firmennetze blocken das gern) und init() bricht ohne
   window.THREE oder WebGL still ab: „3D wird geladen …“ bleibt ewig
   stehen, Cookie-Klicks laufen ins Leere. Deshalb: sobald die Bühne
   sichtbar ist und nach 6 s kein <canvas> existiert → 3D ausblenden
   und Hinweis + Link auf die fertigen Boxen zeigen.
   --------------------------------------------------------------- */
(function(){
  'use strict';
  function init(){
    var stage = document.getElementById('stage3d');
    if (!stage) return;
    function fallback(){
      if (stage.querySelector('canvas')) return;
      if (document.getElementById('bybFallback')) return;
      stage.style.display = 'none';
      var d = document.createElement('div');
      d.id = 'bybFallback';
      d.setAttribute('style', 'margin:18px auto;padding:26px 22px;max-width:420px;text-align:center;border-radius:22px;background:rgba(10,31,61,.06);border:1px solid rgba(10,31,61,.14)');
      d.innerHTML = '<p style="font-weight:700;margin:0 0 6px">Die 3D-Ansicht kann auf diesem Gerät nicht geladen werden.</p>' +
        '<p style="margin:0 0 16px;opacity:.75">Kein Problem — unsere fertig kuratierten Boxen findest du hier:</p>' +
        '<a class="btn btn-navy" href="/collections/vorgewahlte-boxen">Zu den Cookie-Boxen</a>';
      stage.parentNode.insertBefore(d, stage.nextSibling);
    }
    if (!('IntersectionObserver' in window)){ setTimeout(fallback, 9000); return; }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (e.isIntersecting){ io.disconnect(); setTimeout(fallback, 6000); }
      });
    }, { threshold: 0.15 });
    io.observe(stage);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
